const {
  hasContentValue
} = require('@truqc/content-path');
const {
  evaluateSource
} = require('../lib/evaluateSource');

/**
  * @function evalute - evaluate hasContentBehavior
  */

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const value = await evaluateSource(source.value, content, parentContentPath, transientContext, nativeFunctions);
  return hasContentValue(value);
};
module.exports = {
  evaluate
};